/**
 * Styled Components - Created by gustavomedina on 04/05/18.
 */
import styled from 'styled-components'
import Select from 'antd/lib/select'
import Input from 'antd/lib/input'
import Icon from 'antd/lib/icon'
import InputNumber from 'antd/lib/input-number'
import {
  GRAY_LIGHT,
  RED,
  GRAY,
  GRAY_SOFT,
  GRAY_DARK,
  GRAY_ANTDESIGN,
  BLUE,
  WHITE,
  GRAY_STRONG,
  BLACK,
  ORANGE
} from '../../theme/colors'

type SelectType = {
  selectWidth?: string
  highlightFields?: boolean
}

interface StyledProps {
  selected?: boolean
  withBorder?: boolean
  marginLeft?: string
  disabled?: boolean
  highlight?: boolean
}

export const Table = styled.div`
  table-layout: fixed;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 15px;
  padding-left: 16px;
  padding-right: 16px;
  display: table;
  @media (max-width: 767px) {
    display: auto;
  }
  @media (max-width: 640px) {
    margin-bottom: 0;
    padding: 0;
  }
`

export const Body = styled.tbody``

type RowProps = {
  withColor?: boolean
  onlyRead?: boolean
  withTwoPieces?: boolean
  upgradeOne?: boolean
  isMobile?: boolean
  upgradeTwo?: boolean
  upgradeThree?: boolean
  lengthColor?: number
  secondary?: boolean
}

export const Row = styled.div`
  display: table-row;
  grid-template-columns: ${({
      withColor,
      onlyRead,
      withTwoPieces,
      upgradeOne,
      upgradeTwo,
      upgradeThree,
      isMobile,
      lengthColor
    }: RowProps) => {
    let upgrade = 0
    if (upgradeOne && !isMobile) {
      upgrade += 1 
    }
    if (upgradeTwo && !isMobile) {
      upgrade += 1
    }
    if (upgradeThree && !isMobile) {
      upgrade += 1
    }
    if (withColor) {
      return onlyRead ? 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}` : 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}`
    }
    return !withTwoPieces ? `repeat(${4 + upgrade}, 1fr)` : `repeat(${5 + upgrade}, 1fr)`
  }};
  grid-gap: ${({ withColor }: RowProps) => (withColor ? '10px' : '3px')};

  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${GRAY_LIGHT};
  padding-bottom: 8px;
  padding-top: 8px;
  ${({ secondary }: RowProps) => secondary ? `
    display: inline-grid;
    width: 300%;
  ` : ''}
  @media (max-width: 1000px) {
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
  }
  @media (max-width: 698px) {
    justify-content: space-evenly;
    padding: 3px 3px;
  }
`

export const HeaderRow = styled.div`
  display: table-header-group;
  grid-template-columns: ${({ 
    withColor,
    onlyRead,
    withTwoPieces,
    upgradeOne,
    upgradeTwo,
    upgradeThree,
    lengthColor
  }: RowProps) => {
    let upgrade = 0
    if (upgradeOne) {
      upgrade += 1 
    }
    if (upgradeTwo) {
      upgrade += 1
    }
    if (upgradeThree) {
      upgrade += 1
    }
    if (withColor) {
      return onlyRead ? 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}` : 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}`
    }
    return !withTwoPieces ? `repeat(${4 + upgrade}, 1fr)` : `repeat(${5 + upgrade}, 1fr)`
  }};
  grid-gap: ${({ withColor }: RowProps) => (withColor ? '10px' : '5px')};
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${GRAY_SOFT};
  padding-bottom: 4px;
  @media (max-width: 1280px) {
    display: ${({ upgradeOne, upgradeTwo, upgradeThree }: RowProps) => 
      upgradeOne && upgradeTwo && upgradeThree ? 'flex' : 'table-header-group'};
    width: 100%;
  }
  @media (max-width: 1000px) {
    display: none;
  }
  @media (max-width: 640px) {
    padding: ${({ withColor }: RowProps) => (withColor ? '0 5px' : '0 7px')};
    grid-gap: ${({ withColor }: RowProps) => (withColor ? '3px' : '5px')};
  }

  @media (min-width: 426px) and (max-width: 640px) {
    padding: ${({ withColor }: RowProps) => (withColor ? '0 5px' : '0 7px')};
    grid-gap: 5px;
  }

  @media (max-width: 425px) {
    padding: ${({ withColor }: RowProps) => (withColor ? '0 5px' : '0 7px')};
    grid-gap: ${({ withColor }: RowProps) => (withColor ? '3px' : '5px')};
  }
`

export const Column = styled.td`
  outline: 1px solid red;
  padding: 0;
`
interface CellProps {
  width?: number
  align?: string
  start?: number
  end?: number
}
export const Cell = styled.div`
  display: table-cell;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding-right: 12px;
  padding-bottom: 12px;
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  flex-flow: ${({ align }: CellProps) => align || 'row'};
  width: ${({ width }: CellProps) => (width ? width : `100%`)};
  @media (max-width: 1000px) {
    display: flex;
    flex-flow: column;
    max-width: 164px;
  }
`

export const CellRemove = styled.div`
  display: table-cell;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding-right: 12px;
  padding-bottom: 12px;
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  flex-flow: ${({ align }: CellProps) => align || 'row'};
  width: ${({ width }: CellProps) => (width ? width : `100%`)};
  @media (max-width: 1000px) {
    display: flex;
    flex-flow: column;
    flex: 1;
    max-width: 100%;
    justify-content: flex-end;
    text-align: right;
    padding: 0;
  }
  @media (max-width: 698px) {
    flex: unset;
    justify-content: center;
    text-align: center;
  }
 `

export const RightInput = styled.div`
  display: flex;
  align-items: center;
`

export const InfoCell = styled.div`
  width: 100%;
  display: table-cell;
  text-align: ${({ align }: CellProps) => (align ? align : 'left')};
  color: ${GRAY_DARK};
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  font-size: 14px;
  padding-bottom: 10px;
  @media (max-width: 1000px) {
    display: flex;
    flex-flow: column;
    max-width: 164px;
    padding-bottom: 8px;
    width: fit-content;
    margin-right: 20px;
  }
`

export const HeaderCell = styled.div`
  text-align: left;
  width: ${({ width }: CellProps) => (width ? width : '100%')};
  display: table-cell;
  padding-bottom: 8px;
  @media (max-width: 767px) {
    display: auto;
  }
`

interface TitleProps {
  align: string
  titleWidth?: string
}

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: ${({ align }: TitleProps) => align};
  width: ${({ titleWidth }: TitleProps) => (titleWidth ? titleWidth : 'auto')};
`

export const Price = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 43px;
  width: 58px;
  text-align: ${({ align }: TitleProps) => (align ? align : 'center')};
`

export const UpgradeTitle = styled.div`
  color: ${GRAY_STRONG};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: left;
  display: flex;
  width: auto;
  word-break: break-all;
`

export const InfoBody = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -38px;
`

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const VariableTitle = styled.div`
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  display: flex;
  width: 100%;
  color: ${GRAY_STRONG};
  text-align: left;
  word-break: break-all;
  @media (max-width: 640px) {
    width: auto;
  }
`

export const InfoTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  text-align: center;
`

export const InfoIcon = styled(Icon)`
  margin-right: 12px;
`

export const InfoDescription = styled.div`
  margin-top: 28px;
  center {
    font-size: 16px;
  }
  ul {
    padding-left: 15px;
    margin-bottom: 0;
    margin-top: 18px;
  }
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  width: 100%;
  @media (max-width: 768px) {
    max-width: 886px;
    margin-top: 0px;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const buttonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const MobileEmtpytable = styled.div`
  padding: 50px 40px 50px;
  border-bottom: 1px solid ${GRAY_LIGHT};
  color: ${GRAY};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 21px;
  text-align: center;
`

export const DeleteItem = styled.div`
  color: ${RED};
  cursor: pointer;
  text-align: right;
  font-weight: bold;
  @media (max-width: 1000px) {
    display: none;
  }
`

export const DeleteItemMobile = styled.div`
  color: ${ORANGE};
  cursor: pointer;
  text-align: right;
  display: none;
  width: 100%;
  justify-content: flex-end;
  flex: 1;
  font-size: 12px;
  @media (max-width: 1000px) {
    display: flex;
  }
  @media (max-width: 698px) {
    justify-content: center;
  }
`

export const StyledSelect = styled(Select)`
  width: ${({ selectWidth }: SelectType) =>
    selectWidth ? selectWidth : '20%'};
  & .ant-select-selection {
    border-color: ${({ highlightFields }: SelectType) =>
    highlightFields ? RED : GRAY_ANTDESIGN};
    transition: all .25s;
  }
  transition: all .25s;
  ${({ highlightFields }: SelectType) => highlightFields ? `
    .ant-select-selection {
      background: #fff3f3;
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    
      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-select-selection {
          background: #white !important;
        }
      }
    
      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    }
  ` : ''}
  @media (max-width: 698px) {
    width: 100%;
  }
`

export const StyledInput = styled(Input)`
  width: 100%;
`

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
  &.ant-input-number {
    border-color: ${({ highlightFields }: SelectType) =>
    highlightFields ? RED : GRAY_ANTDESIGN};
    transition: all .25s;
  }
  transition: all .25s;
  ${({ highlightFields }: SelectType) => highlightFields ? `
    .ant-input-number-input {
      background: #fff3f3;
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-input-number-input {
          background: #fff3f3 !important;
        }
      }
    
      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-input-number-input {
          background: #white !important;
        }
      }
    
      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-input-number-input {
          background: #fff3f3 !important;
        }
      }
    }
  ` : ''}
  .ant-input-number-handler-wrap {
    opacity: 1;
    .anticon {
      color: ${BLACK};
    }
  }
  .ant-input-number-handler-down-disabled {
    .anticon {
      color: ${GRAY_SOFT};
    }
  }
`

export const ProductColor = styled.img`
  border-radius: 50%;
  border: 1px solid ${GRAY};
  width: 30px;
`

export const QuestionSpan = styled.span`
  color: #5f6062;
  font-size: 14px;
  margin-inline: 5px 20px;
  border: 1px solid #c1c1c1;
  background: #f8f8f8;
  font-weight: 500;
  font-family: Avenir;
  padding: 10px;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 22px;
  height: 22px;

  &::after {
    content: '?';
  }
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px) {
    margin-bottom: 6px;
  }
`

export const CellContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ align }: CellProps) => align || 'flex-start'};
  .limitLabel {
    font-size: 12px;
    background: #fff4e0;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    white-space: nowrap;
    @media (max-width: 1080px) {
      margin-left: -64px;
      margin-top: -56px;
    }
  }
`

export const QuantityDiv = styled.div`
  margin-right: -26px;
  margin-left: 10px;
  border-radius: 5px;
  font-size: 13px;
  padding: 2px 6px;
  background: #eef5f6;
  font-weight: 500;
  font-family: Avenir;
  color: #6c9ba1;
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 28px;
  padding: 0px 10px;
  transition: all .25s;
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 11px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  box-shadow: 1px 2px 2px 0px #e1e1e1;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`

export const TitleMobile = styled.div`
  color: ${GRAY_STRONG};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: left;
  width: auto;
  display: none;
  @media (max-width: 1000px) {
    display: flex;
    .limitLabel {
      font-size: 11px;
      background: #fff4e0;
      padding: 4px;
      border-radius: 3px;
      margin-left: 6px;
      white-space: nowrap;
      align-self: center;
      line-height: 1;
      font-weight: normal;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemTable/styledComponents.tsx